var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_84975)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 20,
    fill: "#FDB913"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2915 35.1562C23.3403 35.1562 23.3892 35.152 23.438 35.1455L27.5444 34.5117C27.5933 34.5031 27.6396 34.4838 27.6738 34.4516L38.0229 25.3443C38.0456 25.3245 38.0635 25.3009 38.0758 25.2749C38.088 25.2489 38.0943 25.221 38.0943 25.1929C38.0943 25.1647 38.088 25.1369 38.0758 25.1109C38.0635 25.0849 38.0456 25.0613 38.0229 25.0414L33.9653 21.4686C33.9189 21.4277 33.8579 21.4062 33.792 21.4062C33.7261 21.4062 33.665 21.4277 33.6187 21.4686L23.2695 30.5758C23.2329 30.608 23.2109 30.6467 23.2012 30.6896L22.481 34.3033C22.4572 34.4184 22.4657 34.5369 22.5057 34.6484C22.5457 34.76 22.616 34.8613 22.7104 34.9436C22.8716 35.0811 23.0742 35.1562 23.2915 35.1562ZM24.937 31.4094L33.792 23.6191L35.5815 25.1939L26.7266 32.9842L24.5562 33.3215L24.937 31.4094ZM38.4844 36.9609H20.5156C20.0835 36.9609 19.7344 37.2682 19.7344 37.6484V38.4219C19.7344 38.5164 19.8223 38.5938 19.9297 38.5938H39.0703C39.1777 38.5938 39.2656 38.5164 39.2656 38.4219V37.6484C39.2656 37.2682 38.9165 36.9609 38.4844 36.9609Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_84975",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.72549 0 0 0 0 0.0745098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_84975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_84975",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUpload);
export default __webpack_public_path__ + "static/media/edit-upload.72f17ccb1279b0fe61b5cb83903b832d.svg";
export { ForwardRef as ReactComponent };